import React, { Component } from 'react';
import { db } from '../../firebase/index';

class UploadTemplateInfo extends Component {
  state = {
    collectionName: null,
    name: '',
    marginX: null,
    marginY: null,
    order: null,
    width: null,
    height: null,
    fill: '',
    isBold: false,
    isTransformable: false,
    type: null,
    imageUrl: null,
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleUpload = async () => {
    // const setRedirect = this.setRedirect;
    const { collectionName, name, marginX, marginY, order, width, fill, isBold, isTransformable, type } = this.state;
    const info = {
      name: name,
      marginX: Number(marginX),
      marginY: Number(marginY),
      order: Number(order),
      width: Number(width),
      fill: fill,
      isBold: Boolean(isBold),
      isTransformable: Boolean(isTransformable),
      type: type
    }
    //height imageUrl

    db.collection(collectionName).add(info);
    console.log(info);
  }

  componentDidUpdate() {
  }

  render() {
    return (
      <div>
        <div className="upload-form">
          <div className="field">DocName<input type="text" onChange={this.handleChange} name="collectionName" placeholder="" /></div>

          <div className="field">name<input type="text" onChange={this.handleChange} name="name" placeholder="" /></div>
          <div className="field">marginX<input type="text" onChange={this.handleChange} name="marginX" placeholder="" /></div>
          <div className="field">marginY<input type="text" onChange={this.handleChange} name="marginY" placeholder="" /></div>
          <div className="field">order<input type="text" onChange={this.handleChange} name="order" placeholder="" /></div>
          <div className="field">width<input type="text" onChange={this.handleChange} name="width" placeholder="" /></div>
          <div className="field">height<input type="text" onChange={this.handleChange} name="height" placeholder="" /></div>
          <div className="field">fill<input type="text" onChange={this.handleChange} name="fill" placeholder="" /></div>
          <div className="field">is_bold<input type="text" onChange={this.handleChange} name="isBold" placeholder="" /></div>
          <div className="field">is_transformable<input type="text" onChange={this.handleChange} name="isTransformable" placeholder="" /></div>
          <div className="field">type<input type="text" onChange={this.handleChange} name="type" placeholder="rectangles/image/text" /></div>
          <div className="field">imageUrl<input type="text" onChange={this.handleChange} name="imageUrl" placeholder="ONLY for image" /></div>
          <div className=""><button className="" onClick={this.handleUpload}>Upload</button></div>
          {/* {this.renderRedirect()} */}
          <br />
            
        </div>
      </div>
    );
  }
}

export default UploadTemplateInfo;
